import {NavLink} from "react-router-dom";
import React, {useState} from "react";
import ButtonGetMoreHint from "../../../components/Buttons/buttonGetMoreHint/buttonGetMoreHint";

export default function HintBlockData(request, getFunk) {

    const [valueCount, setValueCount] = useState(5)
    const [selectedShop, setSelectedShop] = useState(localStorage.getItem("SELECTED_SHOP_ID"))


    function getcolor1(persent) {
        let color1
        if (persent < 33) {
            color1 = "var(--progressBarRed1)"
        } else if (persent < 66) {
            color1 = "var(--progressBarOrange1)"
        } else {
            color1 = "var(--progressBarGreen1)"
        }
        return color1;
    }

    function getcolor2(persent) {
        let color2
        if (persent < 33) {
            color2 = "var(--progressBarRed2)"
        } else if (persent < 66) {
            color2 = "var(--progressBarOrange2)"
        } else {
            color2 = "var(--progressBarGreen2)"
        }
        return color2;
    }

    const handleNavLinkClick = (e) => {
        // Если клик был по select или button, не переходим по ссылке
        if (e.target.closest('.custom-select-trigger') ||
            e.target.closest('.custom-select-option') ||
            e.target.closest('.button__add__more__hint') ||
            e.target.closest('.progressAndNewHint__conteiner')
        ) {
            e.preventDefault();
        }
    };

    function handelAttachUser(value) {
        setValueCount(value);
    }

    const handleGetMoreHint = (id, selectedValue) => {
        getFunk(id, selectedShop, selectedValue);
    }

    function calculatePercentage(data) {
        const success = Number(data?.success_task) || 0;
        const count = Number(data?.count_task) || 0;

        if (count === 0) return 100;

        const percentage = (success / count) * 100;
        return Math.min(Math.floor(percentage), 100);
    }

    return(
        request?.map((data) => {
            const isActive = data.success_task === data.count_task  && data.count_additional_task !== 0;

            return (
                <div key={data.id} id={data.id}>
                    <NavLink to={`/HintCard/${data.id}`}
                             state={{data: data.id}}
                             onClick={handleNavLinkClick}
                    >
                        <div className="hint max--width--control">
                            <div className="hint--title" key={data.id}>{data.name}</div>
                            <div className={"hint--title--block__add--hint"}>

                                <ButtonGetMoreHint
                                    data={data}
                                    isActive={isActive}
                                    onGetMoreHint={handleGetMoreHint}
                                    onValueChange={handelAttachUser}
                                />

                                <div className="hint--progress--bar--wrapper">
                                    <div className={"hint--progress--bar"}
                                         style={{
                                             background:
                                                 "radial-gradient(closest-side, var(--block--color) 80%, transparent 80%),\n" +
                                                 `conic-gradient(${getcolor1(calculatePercentage(data))} ${calculatePercentage(data)}%, 
                                                 ${getcolor2(calculatePercentage(data))} 0)`
                                         }}
                                         datacustomattribute={`${calculatePercentage(data)}%`}
                                    >
                                    </div>
                                    <div className="hint--number">
                                        {data.success_task}/{data.count_task}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </NavLink>
                </div>
            )
        })
    )
}